import React, { useEffect, useState } from 'react'
import ReactJkMusicPlayer from 'react-jinke-music-player'
import 'react-jinke-music-player/assets/index.css'

import firebase from "./firebase/firebase";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";


export default function MediaPlayer(){
  
    const [songs, setSongs] = useState([]);

    useEffect(() => {
      getSongs();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    const getSongs = () => {
      var allSongs = [];
      firebase
        .firestore()
        .collection("DownloadUrls")
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.exists) {
              allSongs.push(doc.data());
              var re = Object.values(allSongs);
              setSongs(re);
            }
            
          });
        })
        .catch(err => {
          console.log("error", err);
        });
    };

    const audioList1 = songs.map(item=>(
        {name: item.SongName,
        singer: item.Artist,
        cover:item.Url,
        musicSrc:item.Song,}
      )); 

    
 return(
     <div style={{padding:10}}>
         <ReactJkMusicPlayer
         audioLists={audioList1}
         autoPlay={true}
         mode="full"
         responsive={true}
         />
     </div>
 );
}